import Vue from 'vue'
import Vuex from 'vuex'
import {useSessionStorage} from "@vueuse/core";
import {v4 as uuid} from "uuid";

Vue.use(Vuex)

const sessionId = useSessionStorage('harvia-chat-session-id', uuid(), {mergeDefaults: true});
const store = new Vuex.Store({
  state: {
    count: 0,
    sessionId: sessionId.value
  },
  mutations: {
    increment (state) {
      state.count++
    },
    setSessionId (state, sessionId) {
      state.sessionId = sessionId;
    }
  }
})

export default store;
